
export interface RequestIdleCallbackPayload {
  didTimeout: boolean
  timeRemaining: () => number
}

// Doc for `requestAnimationFrame` & `cancelAnimationFrame`
// https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
// https://developer.mozilla.org/en-US/docs/Web/API/Window/cancelAnimationFrame
declare global {
  interface Window {
    requestIdleCallback?: (callback: (payload: RequestIdleCallbackPayload) => void) => number
    cancelIdleCallback?: (id: number) => void
  }
}

// Polyfill copied & modified from
// https://developers.google.com/web/updates/2015/08/using-requestidlecallback
const requestIdleCallback =
  window.requestIdleCallback || ((callback: (payload: RequestIdleCallbackPayload) => void) => {
    const start = Date.now()
    return setTimeout(() => {
      callback({
        didTimeout:     false,
        timeRemaining:  () => {
          return Math.max(0, 50 - (Date.now() - start))
        },
      })
    }, 1)
  })

const cancelIdleCallback =
  window.cancelIdleCallback || ((id: number) => {
    clearTimeout(id)
  })

export {
  requestIdleCallback,
  cancelIdleCallback,
}
